export default __webpack_public_path__ + "static/media/work.87dcdb42.png";